import { Box, FormHelperText } from "@mui/material";

import { FieldErrorProps } from "@definitions/index";
import { ValidationError } from "@definitions/definitions";


const FieldError = ({ formState, name, textAlign, childKey }: FieldErrorProps) => {
    return <Box
        key={`${childKey ?? name}-error-box`}
        sx={{
            width: "100%",
        }}
        id={`${name}-error`}
        aria-live='polite'
        aria-atomic='true'>
        {formState?.errors[name]?.map(
            (error: ValidationError, index : number) => (
                <FormHelperText
                    sx={{
                        textAlign: textAlign ?? 'left',
                        ml: 0,
                    }}
                    error
                    key={`${childKey ?? name}-${error}-${index}-text`}>
                    {error.message}
                </FormHelperText>
            )
        )}
    </Box>
};

export { FieldError };